(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jumo-quantity-stepper"] && !Shopify.designMode) return;
  try {
    (function () {
    function clamp(input) {
      const min = input.min !== '' ? parseInt(input.min, 10) : -Infinity;
      const max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      let v = parseInt(input.value, 10);
      if (isNaN(v)) v = min === -Infinity ? 0 : min;
      v = Math.max(min, Math.min(max, v));
      input.value = v;
      return { v, min, max };
    }

    function syncButtons(stepper) {
      const input = stepper.querySelector('.jumo-stepper__input');
      if (!input) return;
      const { v, min, max } = clamp(input);
      stepper.querySelectorAll('.jumo-stepper__btn').forEach((btn) => {
        if (btn.dataset.dir === 'down') btn.disabled = v <= min;
        if (btn.dataset.dir === 'up') btn.disabled = v >= max;
      });
    }

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.jumo-stepper__btn');
      if (!btn) return;
      const stepper = btn.closest('.jumo-stepper');
      const input = stepper && stepper.querySelector('.jumo-stepper__input');
      if (!input) return;
      const step = parseInt(input.step, 10) || 1;
      input.value = (parseInt(input.value, 10) || 0) + (btn.dataset.dir === 'up' ? step : -step);
      clamp(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncButtons(stepper);
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('.jumo-stepper__input');
      if (!input) return;
      syncButtons(input.closest('.jumo-stepper'));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
